module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-2-ca9f37d4ecd64f5994fbe4a3dabcc535.png";